import type { ProgramUserRsvp } from 'models';
import { type ReactNode, useCallback } from 'react';
import { CheckCircleFillIcon, CloseCircleFillIcon } from 'ui';
import { useEventRsvpLabels } from '../../../hooks';

export const useGetPastEventStatusInformation = () => {
  const { getPastStatusLabel } = useEventRsvpLabels();

  return useCallback(
    ({ status }: { status?: ProgramUserRsvp }): { icon?: ReactNode; text: string } => {
      switch (status) {
        case 'going':
          return {
            icon: <CheckCircleFillIcon size="small" type="success" />,
            text: getPastStatusLabel({ rsvp: 'going' }),
          };
        case 'not_going':
        case undefined:
          return {
            icon: <CloseCircleFillIcon size="small" type="error" />,
            text: getPastStatusLabel({ rsvp: 'not_going' }),
          };
        case 'pending':
          return { text: getPastStatusLabel({ rsvp: 'pending' }) };
      }
    },
    [getPastStatusLabel],
  );
};
